import React, { useState, useEffect } from 'react';
import { getLastResults, getDetailResults } from '@/services/casinoApi';
import "./Result.css";
import ResultModalLayout from '@/components/ResultModalLayout';

// Map win value to display
const mapWinToDisplay = (winValue) => {
  return 'R';
};

// Helper function to get card image from card code
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  try {
    if (cardCode.length < 3) {
      return null;
    }
    // Use local assets path like other result components
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

// Helper function to extract card rank from card code (e.g., "8CC" -> "8", "KCC" -> "K")
const getCardRank = (cardCode) => {
  if (!cardCode) return '';
  // Remove the last 2 characters (suit) to get the rank
  return cardCode.slice(0, -2);
};

// Helper function to parse card string (format: "8CC,7HH,KCC")
const parseCards = (cardString) => {
  if (!cardString) return { cards: [], ranks: [] };
  
  const cardCodes = cardString.split(',');
  const cards = cardCodes.map(code => getCardImage(code.trim())).filter(Boolean);
  const ranks = cardCodes.map(code => getCardRank(code.trim())).filter(Boolean);
  
  return { cards, ranks };
};

const Result3CardJ = ({
  data = [],
  gameData = {},
  gameType = '3cardj',
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch last results on mount
  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [gameType]);

  const handleResultClick = async (resultItem, index) => {
    setSelectedResult(resultItem);
    setLoading(true);

    const mid = resultItem?.mid;

    if (mid) {
      try {
        const response = await getDetailResults(gameType, mid.toString());
        if (response?.success && response?.data?.data?.t1) {
          setDetailResult(response.data.data.t1);
        }
      } catch (error) {
        console.error('Error fetching detail results:', error);
      }
    }

    setLoading(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedResult(null);
    setDetailResult(null);
  };

  // Format modal data
  const getModalData = () => {
    if (!selectedResult || !detailResult) return null;

    const cardData = parseCards(detailResult.card || "");
    const resultText = cardData.ranks.join('  '); // Join ranks with double space

    return {
      roundId: detailResult.rid || gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || "N/A",
      matchTime: detailResult.mtime || gameData?.data?.data?.mt || new Date().toLocaleString(),
      winner: detailResult.winnat || detailResult.win || "",
      rdesc: detailResult.rdesc || "",
      cards: cardData.cards,
      resultText: resultText
    };
  };

  const modalData = getModalData();

  // Combine API results with fallback data
  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res, idx) => ({ win: res, mid: null }));

  return (
    <>
      {/* Last Results Section */}
      <div className="casino-last-results">
        {allResults.map((resultItem, index) => {
          const displayValue = mapWinToDisplay(resultItem.win);

          return (
            <span
              key={index}
              className="result"
              onClick={() => resultItem.mid && handleResultClick(resultItem, index)}
              style={{ cursor: resultItem.mid ? 'pointer' : 'default' , color:'yellow'}}
            >
              {displayValue}
            </span>
          );
        })}
      </div>

      {/* Modal */}
      {modalData && (
        <ResultModalLayout
          show={showModal}
          onHide={handleCloseModal}
          title="3 Cards Judgement Result"
          roundId={modalData.roundId}
          matchTime={modalData.matchTime}
          loading={loading}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h6 className="text-right">
                  <b>Round Id :</b> {modalData.roundId}
                </h6>
              </div>
            </div>
            <div className="row bottom-border-casino m-t-10">
              <div className="col-md-12">
                <div className="player-image-container row">
                  <div className="text-center player-number col-12">
                    {modalData.cards && modalData.cards.length > 0 && (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                          {modalData.cards.map((cardImage, index) => (
                            <img 
                              key={index}
                              src={cardImage} 
                              alt={`Card ${index + 1}`}
                            />
                          ))}
                        </div>
                        <div className="col-md-12 text-left">
                          <p className="m-b-0 m-t-20">
                            <b>Result:</b> {modalData.resultText}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ResultModalLayout>
      )}
    </>
  );
};

export default Result3CardJ;

